exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-783958dc] .wrap-service{background-color:var(--blue-light-1)}.wrap-list[data-v-783958dc]{margin-left:20px;list-style:disc}@media only screen and (max-width:1200px){[data-v-783958dc] .zb-modal-scrollable-content{background:unset!important}}", ""]);

// exports
